import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=1126d90e&"
import script from "./UIButton.vue?vue&type=script&lang=js&"
export * from "./UIButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports